 Marquee ={
	el:{},
	current:0,
    count:0,
	
	init: function(time){
		this.el = Crypto.el.find('[component="marquee"]');
        this.count = this.el.find('[slide]').length;
		var interval = setInterval(Marquee.change, time);
	},

	change: function(){

        Marquee.el.find(' [slide="' + Marquee.current + '"] ').removeClass('current').addClass('outgoing');

        Marquee.current++;

        if(Marquee.current > Marquee.count -1)
            Marquee.current = 0;

        Marquee.el.find(' [slide="' + Marquee.current + '"] ').addClass('incoming').removeClass('outgoing');
        setTimeout(function(){
            Marquee.el.find(' [slide="' + Marquee.current + '"] ').removeClass('incoming').addClass('current');
        },100)
	}
},